import { render } from "./SwitchRole.vue?vue&type=template&id=5d4c4ca2&scoped=true"
import script from "./SwitchRole.vue?vue&type=script&lang=js"
export * from "./SwitchRole.vue?vue&type=script&lang=js"

import "./SwitchRole.vue?vue&type=style&index=0&id=5d4c4ca2&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4c4ca2"]])

export default __exports__